export default __webpack_public_path__ + "static/media/frame-register-tablet@2x.692d092b.png";